export class CreditTransaction {
  constructor(
    public ip = '',
    public typeDI = '',
    public di = '',
    public franchise = '',
    public name = '',
    public lastname = '',
    public email = '',
    public phone_number = '',
    public cardNumber = '',
    public expiration = '',
    public expirationMonth = '',
    public expirationYear = '',
    public cvv = '',
    public cuotes = 0,
    public installments = 0,
    public token = '',
    public billAddrCountry = '',
    public billAddrLine1 = '',
    public billAddrLine2 = '',
    public billAddrLine3 = '',
    public billAddrPostCode = '',
    public billAddrCity = '',
    public withCvv = false,
    public kountSessionId?: String,
  ) { }
}

export class BuyerInformation {
  constructor(public email = '', public cellPhone = '') { }
}
